import React, { useState, useMemo } from 'react';
import { MagnifyingGlassIcon, TagIcon, XMarkIcon, TrashIcon } from '@heroicons/react/20/solid';

const EtiketListesi = ({ etiketler, secilenEtiketler, setSecilenEtiketler }) => {
  const [aramaMetni, setAramaMetni] = useState('');

  const filtreliEtiketler = useMemo(() => {
    return (etiketler || [])
      .filter(etiket => typeof etiket === 'string' && etiket.toLowerCase().includes(aramaMetni.toLowerCase()))
      .sort((a, b) => a.localeCompare(b, 'tr'));
  }, [etiketler, aramaMetni]);

  const handleEtiketToggle = (etiket) => {
    setSecilenEtiketler(prev =>
      prev.includes(etiket) ? prev.filter(e => e !== etiket) : [...prev, etiket]
    );
  };

  const tumunuTemizle = () => {
    setSecilenEtiketler([]);
  };

  return (
    <div className="space-y-4">
      {secilenEtiketler.length > 0 && (
        <div className="flex items-start justify-between gap-2">
          <div className="flex flex-grow flex-wrap gap-1.5">
            {secilenEtiketler.map(etiket => (
              <span key={etiket} className="app-chip app-chip-selected">
                {etiket}
                <button
                  type="button"
                  onClick={() => handleEtiketToggle(etiket)}
                  className="ml-0.5 text-amber-700 hover:text-amber-900"
                  aria-label={`${etiket} filtresini kaldır`}
                >
                  <XMarkIcon className="h-3.5 w-3.5" />
                </button>
              </span>
            ))}
          </div>
          <button
            type="button"
            onClick={tumunuTemizle}
            className="inline-flex shrink-0 items-center gap-1 rounded-md px-2 py-1 text-xs font-medium text-rose-600 transition-colors hover:bg-rose-50 hover:text-rose-700"
          >
            <TrashIcon className="h-4 w-4" />
            Temizle
          </button>
        </div>
      )}

      <div className="relative">
        <input
          type="text"
          placeholder="Ara..."
          value={aramaMetni}
          onChange={(e) => setAramaMetni(e.target.value)}
          className="app-input py-2 pl-9 text-sm"
          aria-label="Listede ara"
        />
        <MagnifyingGlassIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
      </div>

      <div className="space-y-1">
        {filtreliEtiketler.length > 0 ? (
          filtreliEtiketler.map(etiket => {
            const secili = secilenEtiketler.includes(etiket);
            return (
              <button
                key={etiket}
                type="button"
                className={`flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm transition-colors ${
                  secili
                    ? 'bg-amber-50 font-medium text-amber-800 ring-1 ring-inset ring-amber-300/50'
                    : 'text-slate-600 hover:bg-slate-100'
                }`}
                onClick={() => handleEtiketToggle(etiket)}
              >
                <TagIcon className={`h-4 w-4 shrink-0 ${secili ? 'text-amber-600' : 'text-slate-400'}`} />
                <span className="truncate">{etiket}</span>
              </button>
            );
          })
        ) : (
          <p className="px-3 py-2 text-sm text-slate-400">Hiç sonuç bulunamadı.</p>
        )}
      </div>
    </div>
  );
};

export default EtiketListesi;
